// Native disclosure controls remain usable without JavaScript.
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const opened = [...document.querySelectorAll('.gn-header details[open]')];
  const focused = document.activeElement;
  opened.reverse().forEach(detail => {
    detail.open = false;
    if (detail.contains(focused)) detail.querySelector('summary')?.focus();
  });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.gn-header details[open]').forEach(detail => {
    if (!detail.contains(event.target)) detail.open = false;
  });
});
